export default __webpack_public_path__ + "static/media/success-mobile.05073cd9.png";